"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerCorpus = exports.generate = void 0;
const Context_1 = require("./Context");
require("./builtinFunctions");
const registries_1 = require("./registries");
const walkers_1 = require("./walkers");
function generate(pattern, date, enableEval, env) {
    let context = new Context_1.Context(pattern, date, env);
    if (enableEval) {
        return walkers_1.parseEval(context);
    }
    else {
        return walkers_1.parsePattern(context);
    }
}
exports.generate = generate;
function registerCorpus(corpus) {
    corpus.forEach(([word, partOfSpeech]) => {
        let set = registries_1.corpusRegistry.get(partOfSpeech);
        if (!set) {
            registries_1.corpusRegistry.set(partOfSpeech, set = new Set());
        }
        set.add(word);
    });
}
exports.registerCorpus = registerCorpus;
